"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const node_1 = require("../node");
/**
 * Abstract class for all nodes that represents an expression.
 */
class TwingNodeExpression extends node_1.TwingNode {
}
exports.TwingNodeExpression = TwingNodeExpression;
